import { useNavigate, useParams } from "react-router-dom";
import { QuestionsSummaryModel } from "../../../model/questions-summary.model";
import "./job-question-detail.component.scss";
import { addCandidate, addUsersToJob, checkReportMultipleChoice, cleanCandidate, deleteCandidateByID, deleteJobQuestionById, getCandidatePage, getAllCandidateByFilter, getAllInsightFilterResume, getCandidateByID, getCompany, getInterviewQuestionById, getInterviewQuestionByIdAndUserID, getReportById, postCustomMeasureScore, postForceRegenerateReport, putJobCustomMeasurementCriteria, sendEmailSchedule, UnlockReport, getJobListFromShanti, updateJobIdShanti, removeJobIdShanti, getNonActiveCandidateSummary, getNonActiveCandidates } from "../../../services/api.service";
import { buildInterviewCandidateInviteLink } from "../../../utils/interview-invite-link";
import { useContext, useEffect, useState, useRef } from "react";
import { Alert, Box, Button as MuiButton, Chip, CircularProgress, Collapse, Divider, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Tab, Tabs, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Button } from "react-bootstrap";
import AddCandidateModal from "../../../modal/add-candidate.modal";
import AddCandidatesBulkModal from "../../../modal/add-candidates-bulk.modal";
import { Candidate } from "../../../model/candidate.model";
import ConfirmDeleteModal from "../../../modal/confirm-delete.modal";
import LOADING_JSON from "../../../assets/json/loading.json";
import tokenService from "../../../services/token.service";
import TranscriptLogComponent from "./transcript-log/transcript-log.component";
import { CandidateDetail, ReportModel } from "../../../model/report.modelt";
import COIN_IMG from "../../../assets/images/currency-coin.png";
import PLUS_ICON from "../../../assets/images/plus.png"
import AI_PURPLE from "../../../assets/images/ai-icon-purple.png";
import ADD_CANDIDATE_IMG from "../../../assets/images/add-candidate.png";
import dayjs from "dayjs";
import "dayjs/locale/th";
import SHARE_IMG from "../../../assets/images/share-black.png";
import TRASH_IMG from "../../../assets/images/trash.png";
import CandidateSummary from "./candidate-summary/candidate-summary.component";
import CandidateReport from "./candidate-report/candidate-report.component";
import ShareCandidateModal from "../../../modal/share-candidate.modal";
import { ProviderContext } from "../../../contexts/provider.context";
import config from "../../../config";
import CreditEmpty from "../../../shared/credit-empty/credit-empty.shared";
import ConfirmGeneralModal from "../../../modal/confirm-general.modal";
import Lottie from "lottie-react";
import PremiumModal from "../../../modal/premium.modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronLeft, faChevronRight, faPenToSquare, faShare } from "@fortawesome/free-solid-svg-icons";
import useDeviceType from "../../../utils/device-type.util";
import { ResultMultipleChoice } from "../../../model/summary-multiple-choice.model";
import { isMultipleChoiceLike, MULTIPLE_CHOICE, MULTIPLE_CHOICE_NO_ANSWER } from "../../../shared/question-type.util";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import LoadingGeneralModal from "../../../modal/loading-general.modal";
import UserAccessModal from "../../../modal/user-management.modal";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { PDFDownloadLink } from '@react-pdf/renderer';
import CandidateReportPDF from './CandidateReportPDF';
import InsightDashboardComponent from "./insight-dashboard/insight-dashboard.component";
import GeneralQuestionnaireDashboard from "./general-questionnaire-dashboard/general-questionnaire-dashboard.component";
import JobKpiDashboardModal from "./job-kpi-dashboard-modal/job-kpi-dashboard-modal.component";

export enum ENUM_FILTER_STATUS {
    ALL = "ALL",
    INTERVIEW = "WAITING_INTERVIEW",
    COMPLETED = "COMPLETED",
    SCORE_DESC = "SCORE_DESC",
}

export enum ENUM_FILTER_DATE {
    ALL = "ALL",
    CUSTOM = "CUSTOM"

}
type CandidateSortKey = "name" | "ranking" | "email" | "job" | "status" | "date";
const ITEMS_PER_PAGE = 50;
const CANDIDATE_SERVER_PAGE_SIZE = 50;

/** ผู้ดูอย่างเดียว (viewer) ไม่ลบผู้สมัครได้ — คนอื่นใน admin ลบได้ */
const canDeleteCandidate = (roleName: string | undefined) =>
    roleName !== "ROLE_VIEWER";

const JobQuestionDetail = () => {
    const { profileModel, refreshCompanyCredits }: any = useContext(ProviderContext);
    const { company_id, interview_id, candidate_id } = useParams<{ company_id: string, interview_id: string, candidate_id: string }>();
    const [interviewModel, setInterviewModel] = useState<QuestionsSummaryModel>();
    const [customMeasureDraft, setCustomMeasureDraft] = useState("");
    const [isEditingCustomMeasure, setIsEditingCustomMeasure] = useState(true);
    const [isCustomMeasureExpanded, setIsCustomMeasureExpanded] = useState(false);
    const [savingCustomMeasure, setSavingCustomMeasure] = useState(false);
    const [customMeasureFeedback, setCustomMeasureFeedback] = useState<{
        severity: "success" | "error";
        text: string;
    } | null>(null);
    const [customMeasureDashboardOpen, setCustomMeasureDashboardOpen] = useState(false);
    const [confirmReanalyzeAllCustomInsight, setConfirmReanalyzeAllCustomInsight] = useState(false);
    const [reanalyzeAllCustomInsightRunning, setReanalyzeAllCustomInsightRunning] = useState(false);
    const [confirmForceRegenerateAllReports, setConfirmForceRegenerateAllReports] = useState(false);
    const [forceRegenerateAllReportsRunning, setForceRegenerateAllReportsRunning] = useState(false);
    const [isLoadingCandidateList, setIsLoadingCandidateList] = useState(false);
    const [candidateListLoadCount, setCandidateListLoadCount] = useState(0);
    const [isJobSettingsOpen, setIsJobSettingsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmittingCandidate, setIsSubmittingCandidate] = useState(false);
    const [tabActive, setTabActive] = useState(0);
    const [totalResume, setTotalResume] = useState(0);
    const [isAddCandidate, setIsAddCandidate] = useState(false);
    const [isAddCandidatesBulk, setIsAddCandidatesBulk] = useState(false);
    const [bulkInviteProgress, setBulkInviteProgress] = useState<{ total: number; done: number; skipped: number } | null>(null);
    const [candidateList, setCandidateList] = useState<Candidate[]>([]);
    const [candidateHasMore, setCandidateHasMore] = useState(false);
    const [candidatePageCursors, setCandidatePageCursors] = useState<Record<number, string | null>>({ 1: null });
    const [candidateQueryMode, setCandidateQueryMode] = useState<"default" | "score_desc">("default");
    const [candidateProfile, setCandidateProfile] = useState<Candidate>();
    const [isDelete, setIsDelete] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    const [isAddUser, setIsAddUser] = useState(false);
    const [loadingReport, setLoadingReport] = useState(false);
    const [isConfirmUnlock, setIsConfirmUnlock] = useState(false);
    const [isCandidateShare, setIsCandidateShare] = useState(false);
    const [isSendingEmail, setIsSendingEmail] = useState(false);
    const [shareID, setShareID] = useState<Candidate>();
    const [ResultMultipleChoice, setResultMultipleChoice] = useState<ResultMultipleChoice[]>([]);
    const [deleteCandidateID, setDeleteCandidateID] = useState("");
    const [creditModel, setCreditModel] = useState<any>();
    const { isMobile, isTablet, isDesktop } = useDeviceType();
    const [filterStatus, setFilterStatus] = useState<ENUM_FILTER_STATUS>(ENUM_FILTER_STATUS.ALL);
    const [filterDateStatus, setFilterDateStatus] = useState<ENUM_FILTER_DATE>(ENUM_FILTER_DATE.ALL);
    const [sectionList, setSectionList] = useState({
        summary: true,
        ai_summary: true,
    });
    const [isClickDeleteCandidate, setIsClickDeleteCandidate] = useState(false);
    const [reportModel, setReportModel] = useState<ReportModel | undefined>();
    const [isNoReport, setIsNoReport] = useState(false);
    const [isPremium, setIsPremium] = useState(false);
    const [startDate, setStartDate] = useState<Date | null>(dayjs().toDate());
    const [endDate, setEndDate] = useState<Date | null>(dayjs().toDate());
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    /** ผู้สมัครที่ลบ/ปฏิเสธ — ไม่รวมในรายการ ACTIVE */
    const [nonActiveSummary, setNonActiveSummary] = useState<{
        deleted_count: number;
        rejected_count: number;
    } | null>(null);
    const [candidateSort, setCandidateSort] = useState<{ key: CandidateSortKey; direction: "asc" | "desc" }>({
        key: "date",
        direction: "desc",
    });
    const [nonActivePanelOpen, setNonActivePanelOpen] = useState(false);
    const [nonActiveStatusTab, setNonActiveStatusTab] = useState<"DELETED" | "REJECTED">("DELETED");
    const [nonActiveList, setNonActiveList] = useState<Candidate[]>([]);
    const [nonActiveListLoading, setNonActiveListLoading] = useState(false);
    const reportRef = useRef<HTMLDivElement>(null);
    
    // Job mapping states
    const [jobList, setJobList] = useState<any[]>([]);
    const [selectedJobId, setSelectedJobId] = useState<string>("");
    const [isLoadingJobs, setIsLoadingJobs] = useState(false);
    const [mappedJobIdShanti, setMappedJobIdShanti] = useState<string | null>(null);
    useEffect(() => {
        getCompanyCredit();
    }, [])
    useEffect(() => {
        if (!interview_id) return;
        if (!profileModel?.roleName) return;
        if (profileModel.roleName !== "ROLE_SUPER_ADMIN" && !profileModel.uuid) return;

        if (profileModel.roleName === "ROLE_SUPER_ADMIN") {
            getJobQuestionId();
        } else {
            getJobQuestionIdByUserID(profileModel.uuid);
        }

        getAllCandidateList();
        // โหลดรองหลังเฟรมแรก — ลดการแย่งคิวเครือข่ายกับ interview + รายชื่อผู้สมัคร
        const t = window.setTimeout(() => {
            // filter-resumes = total resumes + UTM (หนึ่ง query Firestore แทน all-resumes ซ้ำ)
            void Promise.all([getFilterResumesInsight(), fetchJobList()]);
        }, 0);

        return () => clearTimeout(t);
    }, [interview_id, profileModel?.roleName, profileModel?.uuid]);

    const refreshNonActiveSummary = () => {
        if (!interview_id) return;
        getNonActiveCandidateSummary(interview_id)
            .then((res) => {
                if (res.data?.is_success && res.data?.data) {
                    setNonActiveSummary(res.data.data);
                }
            })
            .catch(() => {
                setNonActiveSummary(null);
            });
    };

    useEffect(() => {
        refreshNonActiveSummary();
    }, [interview_id]);

    const loadNonActiveList = (status: "DELETED" | "REJECTED") => {
        if (!interview_id) return;
        setNonActiveListLoading(true);
        getNonActiveCandidates(interview_id, status, 200)
            .then((res) => {
                if (res.data?.is_success && Array.isArray(res.data.data)) {
                    setNonActiveList(res.data.data as Candidate[]);
                } else {
                    setNonActiveList([]);
                }
            })
            .catch(() => setNonActiveList([]))
            .finally(() => setNonActiveListLoading(false));
    };
    
    // Load mapped job-id-shanti from interviewModel
    useEffect(() => {
        if (interviewModel && interviewModel['job-id-shanti']) {
            setMappedJobIdShanti(interviewModel['job-id-shanti']);
        } else {
            setMappedJobIdShanti(null);
        }
    }, [interviewModel])

    /** โหลด candidate + report ครั้งเดียวต่อการเปลี่ยน candidate (เดิมซ้ำกับ getAllCandidateList) */
    useEffect(() => {
        if (!candidate_id || !interview_id) return;
        setLoadingReport(true);
        setReportModel(undefined);
        getCandidateByCandidateID(interview_id, candidate_id);
    }, [candidate_id, interview_id]);


    const getCompanyCredit = () => {

        getCompany(company_id).then((res) => {

            if (res.data.is_success) {
                const result = res.data.message;
                setCreditModel(result);
            }
        })
    }

    const handleChangeFilter = (event: SelectChangeEvent<ENUM_FILTER_STATUS>) => {
        setFilterStatus(event.target.value as ENUM_FILTER_STATUS);
        // trigger filter logic here
    };
    const handleChangeDateFilter = (event: SelectChangeEvent<ENUM_FILTER_DATE>) => {
        setFilterDateStatus(event.target.value as ENUM_FILTER_DATE);
        // trigger filter logic here
    };

    /** หน้านี้แสดงได้ก็ต่อเมื่อได้ชุดคำถาม (template/question) — ไม่ใช่แค่ /api/candidate เสร็จ */
    const getJobQuestionId = () => {
        setIsLoading(true);
        getInterviewQuestionById(interview_id)
            .then((res) => {
                if (res.data.is_success) {
                    const result = res.data.data as QuestionsSummaryModel;
                    setInterviewModel(result);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => setIsLoading(false));
    };

    const getJobQuestionIdByUserID = (user_uuid) => {
        setIsLoading(true);
        getInterviewQuestionByIdAndUserID(interview_id, user_uuid)
            .then((res) => {
                if (res.data.is_success) {
                    const result = res.data.data as QuestionsSummaryModel;
                    setInterviewModel(result);
                } else {
                    navigate("/" + tokenService.getHR9CompanyUUID() + "/job-questions-list");
                }
            })
            .catch((err) => {
                console.log(err);
                navigate("/" + tokenService.getHR9CompanyUUID() + "/job-questions-list");
            })
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        if (!interviewModel?.job_question_id || interviewModel.job_question_id !== interview_id) {
            return;
        }
        const existing = interviewModel.custom_measurement_criteria ?? "";
        setCustomMeasureDraft(existing);
        setIsEditingCustomMeasure(existing.trim().length === 0);
    }, [interview_id, interviewModel?.job_question_id, interviewModel?.custom_measurement_criteria]);

    const handleSaveCustomMeasurementCriteria = async () => {
        if (!company_id || !interview_id) return;
        setCustomMeasureFeedback(null);
        setSavingCustomMeasure(true);
        try {
            const res = await putJobCustomMeasurementCriteria(interview_id, customMeasureDraft);
            const d = res.data as {
                is_success?: boolean;
                data?: { custom_measurement_criteria?: string };
                error?: string;
                message?: string;
            };
            if (d?.is_success && d?.data) {
                const saved = d.data.custom_measurement_criteria ?? customMeasureDraft.trim();
                setInterviewModel((prev) => (prev ? { ...prev, custom_measurement_criteria: saved } : prev));
                setCustomMeasureDraft(saved);
                setIsEditingCustomMeasure(false);
                setCustomMeasureFeedback({
                    severity: "success",
                    text: "บันทึกแล้ว — เกณฑ์นี้ใช้กับทุกผู้สมัครในรายการนี้",
                });
            } else {
                setCustomMeasureFeedback({
                    severity: "error",
                    text: d?.error || d?.message || "บันทึกไม่สำเร็จ",
                });
            }
        } catch (e: any) {
            setCustomMeasureFeedback({
                severity: "error",
                text:
                    e.response?.data?.error ||
                    e.response?.data?.message ||
                    e.message ||
                    "บันทึกไม่สำเร็จ",
            });
        } finally {
            setSavingCustomMeasure(false);
        }
    };

    const getCustomInsightReanalyzeTargets = (): Candidate[] =>
        candidateList.filter(
            (c) =>
                c.status !== "DELETED" &&
                c.interview_status === "COMPLETED" &&
                !!c.report_id,
        );

    const getForceRegenerateReportTargets = (): Candidate[] =>
        candidateList.filter(
            (c) =>
                c.status !== "DELETED" &&
                c.interview_status === "COMPLETED" &&
                !!c.report_id,
        );

    const canShowForceRegenerateAllReports = profileModel?.roleName !== "ROLE_VIEWER";

    const runForceRegenerateOne = async (c: Candidate) =>
        postForceRegenerateReport(String(c.report_id), {
            force: true,
            send_email: true,
        });

    const handleConfirmForceRegenerateAllReports = async () => {
        setConfirmForceRegenerateAllReports(false);
        const targets = getForceRegenerateReportTargets();
        if (targets.length === 0) {
            alert("ไม่มีรายงานที่สัมภาษณ์เสร็จสำหรับ Force regenerate");
            return;
        }

        setForceRegenerateAllReportsRunning(true);
        let ok = 0;
        let fail = 0;
        for (const c of targets) {
            try {
                const res = await runForceRegenerateOne(c);
                if (res?.data?.is_success) ok++;
                else fail++;
            } catch {
                fail++;
            }
        }
        setForceRegenerateAllReportsRunning(false);
        if (fail > 0) {
            alert(`Force regenerate เสร็จแล้ว: สำเร็จ ${ok} รายการ, ไม่สำเร็จ ${fail} รายการ`);
        } else {
            alert(`Force regenerate report ทั้งชุดสำเร็จ ${ok} รายการ`);
        }
    };

    const handleConfirmReanalyzeAllCustomInsight = async () => {
        setConfirmReanalyzeAllCustomInsight(false);
        const criteria = (interviewModel?.custom_measurement_criteria ?? "").trim();
        if (!criteria) {
            setCustomMeasureFeedback({
                severity: "error",
                text: "ยังไม่มีเกณฑ์การวัดผล — บันทึกเกณฑ์ก่อน",
            });
            return;
        }
        const targets = getCustomInsightReanalyzeTargets();
        if (targets.length === 0) {
            setCustomMeasureFeedback({
                severity: "error",
                text: "ไม่มีผู้สมัครที่สัมภาษณ์แล้วและมีรายงานสำหรับวิเคราะห์ Custom Insight",
            });
            return;
        }
        setCustomMeasureFeedback(null);
        setReanalyzeAllCustomInsightRunning(true);
        let ok = 0;
        let fail = 0;
        for (const c of targets) {
            try {
                const res = await postCustomMeasureScore(c.report_id as string, { force: true });
                const d = res.data as { is_success?: boolean };
                if (d?.is_success) ok++;
                else fail++;
            } catch {
                fail++;
            }
        }
        try {
            if (interview_id) {
                setCandidatePageCursors({ 1: null });
                setCandidateHasMore(false);
                setCurrentPage(1);
                await loadCandidatePage(1);
            }
        } catch {
            // ignore refresh failure
        }
        setReanalyzeAllCustomInsightRunning(false);
        setCustomMeasureFeedback({
            severity: fail > 0 ? "error" : "success",
            text:
                fail > 0
                    ? `Re Analyze All (Custom Insight): สำเร็จ ${ok} รายการ ไม่สำเร็จ ${fail} รายการ (อาจเป็นเครดิตหรือข้อผิดพลาดจากระบบ)`
                    : `Re Analyze All (Custom Insight) เสร็จ ${ok} รายการแล้ว`,
        });
    };

    const getCandidateByCandidateID = (interview_id, candidate_id) => {
        getCandidateByID(interview_id, candidate_id).then((res) => {
            if (res.data.is_success) {
                const profile = res.data.data as Candidate;
                setCandidateProfile(profile);
                if (profile.report_id) {
                    getReportDetail(profile.report_id);
                    toCheckMultipleChoice(profile.report_id);
                } else {
                    setLoadingReport(false);
                }
            }
        }).catch((err) => {
            setLoadingReport(false);
            navigate("/" + tokenService.getHR9CompanyUUID() + "/job/" + interview_id)
        })
    }

    const updateSection = (field) => {
        if (sectionList) {
            const sectionMod = { ...sectionList };
            if (field == "summary") {
                sectionMod.summary = !sectionMod.summary;
            } else if (field == "ai_summary") {
                sectionMod.ai_summary = !sectionMod.ai_summary;
            }
            console.log(field);
            setSectionList(sectionMod);

        }
    }

    const getReportDetail = (report_id) => {
        getReportById(report_id).then((res) => {
            if (res.data.is_success) {
                console.log(res.data.data);
                const result = res.data.data as ReportModel;
                setReportModel(result);
                setIsNoReport(false);
                setLoadingReport(false);

            }
        }).catch((err) => {
            console.log(err);
            setLoadingReport(false);
            setIsNoReport(true);
        })
    }

    // Fetch job list from Shanti
    const fetchJobList = async () => {
        setIsLoadingJobs(true);
        try {
            const response = await getJobListFromShanti(company_id);
            if (response.data.is_success) {
                setJobList(response.data.data || []);
            }
        } catch (error) {
            console.error("Error fetching job list:", error);
        } finally {
            setIsLoadingJobs(false);
        }
    }

    // Update job-id-shanti (backend returns 409 if job already mapped to another set)
    const handleUpdateJobIdShanti = async () => {
        if (!selectedJobId) return;
        
        try {
            const response = await updateJobIdShanti(company_id, interview_id, selectedJobId);
            if (response.data.is_success) {
                setMappedJobIdShanti(selectedJobId);
                setSelectedJobId("");
                // Refresh interview model
                if (profileModel.roleName === "ROLE_SUPER_ADMIN") {
                    getJobQuestionId();
                } else {
                    getJobQuestionIdByUserID(profileModel.uuid);
                }
            }
        } catch (error: any) {
            if (error.response?.status === 409) {
                alert(error.response.data.error || "This job is already mapped to another interview question set.");
            } else {
                console.error("Error updating job-id-shanti:", error);
                alert("Failed to update job mapping. Please try again.");
            }
        }
    }

    // Remove job-id-shanti
    const handleRemoveJobIdShanti = async () => {
        try {
            const response = await removeJobIdShanti(company_id, interview_id);
            if (response.data.is_success) {
                setMappedJobIdShanti(null);
                // Refresh interview model
                if (profileModel.roleName === "ROLE_SUPER_ADMIN") {
                    getJobQuestionId();
                } else {
                    getJobQuestionIdByUserID(profileModel.uuid);
                }
            }
        } catch (error) {
            console.error("Error removing job-id-shanti:", error);
            alert("Failed to remove job mapping. Please try again.");
        }
    }

    const onClickAddCandidate = () => {
        setIsAddCandidate(true);
    }

    const onClickAddCandidatesBulk = () => {
        setIsAddCandidatesBulk(true);
    }

    const loadCandidatePage = (page: number, mode: "default" | "score_desc" = candidateQueryMode) => {
        if (!interview_id) return;
        if (page < 1) return;
        const afterDocId = candidatePageCursors[page];
        if (page !== 1 && afterDocId === undefined) return;
        setIsLoadingCandidateList(true);
        setCandidateListLoadCount(0);
        getCandidatePage(interview_id, {
            limit: CANDIDATE_SERVER_PAGE_SIZE,
            after_doc_id: afterDocId || undefined,
            disable_custom_sort: true,
            ...(mode === "score_desc"
                ? { filter_status: "COMPLETED", sort_by: "score_desc" }
                : {}),
        })
            .then((res) => {
                if (res.data.is_success) {
                    const result = res.data.data as Candidate[];
                    const pag = (res.data.pagination || {}) as { has_more?: boolean; next_after_doc_id?: string | null };
                    setCandidateListLoadCount(result.length);
                    setCandidateHasMore(!!pag?.has_more && !!pag?.next_after_doc_id);
                    setCandidatePageCursors((prev) => {
                        const next = { ...prev, [page]: afterDocId ?? null };
                        if (pag?.has_more && pag?.next_after_doc_id) {
                            next[page + 1] = pag.next_after_doc_id;
                        } else if (next[page + 1]) {
                            delete next[page + 1];
                        }
                        return next;
                    });
                    setCurrentPage(page);

                    setCandidateList(result);
                    if (result && result.length > 0) {
                        if (candidate_id) {
                            const idx = result.findIndex((item) => item.candidate_id === candidate_id);
                            if (idx >= 0) {
                                setCandidateProfile(result[idx]);
                            }
                            // รายละเอียด + report: ให้ useEffect([candidate_id, interview_id]) เรียก getCandidateByCandidateID ครั้งเดียว
                        } else {
                            // Keep user on /job/:interview_id route.
                            // Select first candidate in local state only, without URL redirect.
                            setCandidateProfile(result[0]);
                        }
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setIsLoadingCandidateList(false);
            });
    };
    const getAllCandidateList = () => {
        setCandidateQueryMode("default");
        setCandidatePageCursors({ 1: null });
        setCandidateHasMore(false);
        setCurrentPage(1);
        loadCandidatePage(1, "default");
    };

    const openDeleteCandidateModal = (id: string) => {
        setDeleteCandidateID(id);
        setIsClickDeleteCandidate(true);
    };

    const closeDeleteCandidateModal = () => {
        setIsClickDeleteCandidate(false);
        setDeleteCandidateID("");
    };

    const submitCandidate = (candidate: Candidate) => {
        setIsSubmittingCandidate(true);
        addCandidate(candidate, interview_id).then((res) => {
            if (res.data.is_success) {
                sendEmailAction(candidate
                    .email, candidate.firstname + " " + candidate.lastname, res.data.candidate.candidate_id)
            }
        }).catch((err) => {
            if (err.response.status == 400) {
                if (err.response.data.error.includes("already exists")) {
                    alert("อีเมลผู้สมัครถูกใช้ไปแล้ว");
                    console.log(err);
                    setIsSubmittingCandidate(false);
                    setIsAddCandidate(true);
                } else if (err.response.data.error.includes("This candidate is already active in the interview list")) {
                    alert("อีเมลผู้สมัครถูกใช้ไปแล้ว");
                    console.log(err);
                    setIsSubmittingCandidate(false);
                    setIsAddCandidate(true);
                }

            }
        })

    }

    const submitCandidatesBulk = async (
        candidates: Candidate[],
        _meta: { total: number; skippedAlreadyInvited: number; skippedInvalid: number },
    ) => {
        if (!interview_id) return;
        if (!interviewModel) return;
        setIsSubmittingCandidate(true);
        setBulkInviteProgress({ total: candidates.length, done: 0, skipped: 0 });
        try {
            const companyMeta = profileModel.companyManageResponses.filter((item) => item.companyUuid == company_id)[0];
            for (let i = 0; i < candidates.length; i += 1) {
                const c = candidates[i];
                try {
                    const res = await addCandidate(c, interview_id);
                    if (res?.data?.is_success) {
                        const newCandidateId = res.data?.candidate?.candidate_id;
                        if (newCandidateId) {
                            await sendEmailSchedule({
                                email: c.email,
                                name: `${c.firstname} ${c.lastname}`.trim(),
                                job: interviewModel.job_position.name || interviewModel.job_position.job_title,
                                imgCover: companyMeta?.companyLogoImageUrl,
                                companyName: companyMeta?.companyName,
                                inviteLink: buildInterviewCandidateInviteLink(
                                    interviewModel.job_question_id,
                                    newCandidateId,
                                ),
                                job_question_id: interviewModel.job_question_id,
                                candidate_id: newCandidateId,
                            });
                        }
                    } else {
                        setBulkInviteProgress((p) => (p ? { ...p, skipped: p.skipped + 1 } : p));
                    }
                } catch (e: any) {
                    setBulkInviteProgress((p) => (p ? { ...p, skipped: p.skipped + 1 } : p));
                } finally {
                    setBulkInviteProgress((p) => (p ? { ...p, done: Math.min(p.total, p.done + 1) } : p));
                }
            }
        } finally {
            getAllCandidateList();
            setBulkInviteProgress(null);
            setIsSubmittingCandidate(false);
            setIsAddCandidatesBulk(false);
        }
    };

    const onclickCandidate = (candidate: Candidate) => {
        const targetInterviewId = interviewModel?.job_question_id || interview_id;
        const targetCandidateId = String(
            candidate?.candidate_id || (candidate as any)?.candidateId || "",
        ).trim();

        if (!targetInterviewId || !targetCandidateId) {
            console.warn("Skip navigate: missing interview_id or candidate_id", {
                targetInterviewId,
                candidate,
            });
            return;
        }

        navigate(
            "/" +
                tokenService.getHR9CompanyUUID() +
                "/job/" +
                targetInterviewId +
                "/" +
                targetCandidateId,
        );
    }

    const deleteJob = () => {
        setIsDelete(true);
    }

    const handleChangeTab = (value) => {
        setTabActive(value);
    }
    const onConfirmDeleteCandidate = () => {
        if (deleteCandidateID) {
            deleteCandidateByID(interview_id, deleteCandidateID).then((res) => {
                if (res.data.is_success) {
                    closeDeleteCandidateModal();
                    getAllCandidateList();
                    refreshNonActiveSummary();
                    refreshCompanyCredits?.();
                    const refunded = res.data?.data?.credit_refunded === true;
                    if (refunded) {
                        alert("ลบผู้สมัครแล้ว — ระบบคืน report credit แล้ว (รายงานที่สัมภาษณ์จบถูกยกเลิกการนับเครดิต)");
                    }
                }
            });
        }

    }
    const onConfirmDelete = () => {
        deleteJobQuestionById(interview_id).then((res) => {
            if (res.data.is_success) {
                setIsDelete(false);
                refreshCompanyCredits?.();
                const freed = res.data?.data?.template_credit_freed === true;
                const reportVoided = Number(res.data?.data?.completed_reports_voided ?? 0) || 0;
                const msgParts: string[] = [];
                if (freed) msgParts.push("คืน Template credit 1 ชุด");
                if (reportVoided > 0) {
                    msgParts.push(
                        `คืน Report credit จากรายงานที่สัมภาษณ์จบแล้ว ${reportVoided} ฉบับ (ตั้งสถานะรายงานเป็น void)`,
                    );
                }
                if (msgParts.length > 0) {
                    alert(`เก็บชุดคำถามเข้าคลังแล้ว — ${msgParts.join(" ")}`);
                }
                navigate("/" + tokenService.getHR9CompanyUUID() + "/job-questions-list")
            }
        });
    }
    const formatDateTime = (dateString: string | Date): string => {
        if (!dateString) return "-";

        const date = new Date(dateString);

        // ✅ Convert to DD/MMM/YYYY / HH:MM (24-hour format)
        return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
            timeZone: "Asia/Bangkok",
        }).replace(",", " /");
    };
    function formatInterviewDate(startIso: string, endIso: string): string {
        const startDate = new Date(startIso);
        const endDate = new Date(endIso);

        const dayOptions: Intl.DateTimeFormatOptions = { day: 'numeric' };
        const monthOptions: Intl.DateTimeFormatOptions = { month: 'short' };

        const startDay = startDate.toLocaleDateString('th-TH', dayOptions);
        const endDay = endDate.toLocaleDateString('th-TH', dayOptions);

        const startMonth = startDate.toLocaleDateString('th-TH', monthOptions);
        const endMonth = endDate.toLocaleDateString('th-TH', monthOptions);

        const startYear = startDate.getFullYear();
        const endYear = endDate.getFullYear();

        if (
            startDay === endDay &&
            startMonth === endMonth &&
            startYear === endYear
        ) {
            // ✅ Same day
            return `${startDay} ${startMonth} ${startYear}`;
        }

        if (startMonth !== endMonth) {
            // ❗ Different months
            return `${startDay} ${startMonth} - ${endDay} ${endMonth} ${endYear}`;
        }

        // ✅ Same month
        return `${startDay} - ${endDay} ${endMonth} ${endYear}`;
    }



    const formatDateThaiShort = (date: string | Date | dayjs.Dayjs): string => {
        return dayjs(date).locale("th").format("D MMM YY");
    };
    const formatDateTimeThaiShort = (date: string | Date | dayjs.Dayjs): string => {
        return dayjs(date).locale("th").format("D MMM YY : HH:mm");
    };
    const formatNonActiveAuditWhen = (iso?: string | null) =>
        iso ? `${formatDateTimeThaiShort(iso)} น.` : "—";
    const formatActorLabel = (email?: string | null, uid?: string | null) => {
        if (email && String(email).trim()) return String(email).trim();
        if (uid && String(uid).trim()) return `UID: ${String(uid).trim()}`;
        return "ไม่ระบุ (ก่อนระบบบันทึกผู้ดำเนินการ)";
    };
    const handleShareCandidate = (candidate) => {
        setShareID(candidate);
        setIsCandidateShare(!isCandidateShare);
    }

    const sendEmailAction = (email, name, candidate_id) => {
        if (interviewModel && email) {
            setIsSendingEmail(true);
            const profileModels = profileModel.companyManageResponses.filter((item) => item.companyUuid == company_id)[0];
            const body = {
                email: email,
                name: name,
                job: interviewModel.job_position.name || interviewModel.job_position.job_title,
                imgCover: profileModels.companyLogoImageUrl,
                companyName: profileModels.companyName,
                inviteLink: buildInterviewCandidateInviteLink(interviewModel.job_question_id, candidate_id),
                job_question_id: interviewModel.job_question_id,
                candidate_id,
            }
            console.log(body);
            try {
                sendEmailSchedule(body).then((res) => {
                    if (res) {
                        getAllCandidateList();
                        setIsSubmittingCandidate(false);
                        setIsAddCandidate(false);
                        setIsSendingEmail(false);
                    }

                })
            } catch (err) {
                alert(err);
                console.log(err);
                setIsSendingEmail(false);
                setIsSubmittingCandidate(false);
                setIsAddCandidate(false);
            }

        } else {
            console.log(interviewModel , email);
            console.log("ข้อมูลไม่ครบ");
        }

    }
    const toCheckMultipleChoice = (report_id) => {
        checkReportMultipleChoice(report_id, interview_id, candidate_id).then((res) => {

            console.log(res);
            if (res.data.is_success) {
                const result = res.data.data as ResultMultipleChoice[];
                setResultMultipleChoice(result);
            }
        }).catch((err) => {
            console.log(err)
        })

    }
    function formatSecondsToTimeString(totalSeconds) {
        try {
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            return [
                hours.toString().padStart(2, '0'),
                minutes.toString().padStart(2, '0'),
                seconds.toString().padStart(2, '0')
            ].join(':');
        } catch {
            return "00:00:00";
        }

    }

    const handleAddUser = () => {
        setIsAddUser(!isAddUser);
    }


    const unlockCandidate = () => {
        if (candidate_id && reportModel && candidateProfile) {
            UnlockReport(reportModel.report_id, company_id, candidate_id, candidateProfile.firstname + " " + candidateProfile.lastname).then((res) => {

                if (res.data.is_success) {
                    navigate("/" + tokenService.getHR9CompanyUUID() + "/job/" + reportModel.job_question_id + "/" + candidate_id)
                    setLoadingReport(true);
                    getReportDetail(reportModel.report_id);
                    setIsConfirmUnlock(false);
                }
            }).catch((err) => {
                alert(err);
                setIsConfirmUnlock(false);
            })

        }
    }
    const clickPremium = () => {
        setIsPremium(true);
    }

    const handleClosePremium = () => {
        setIsPremium(!isPremium)
    }

    const submitPremium = () => {

    }
    const handleDateChange = (value, field) => {
        if (field == "Start Date") {
            setStartDate(value);
        } else {
            setEndDate(value);
        }
    }
    const clickFilter = () => {
        // const filter_start_date = startDate ? format(startDate, 'dd MM yyyy') : null;
        // const filter_end_date = endDate ? format(endDate, 'dd MM yyyy') : null;
        if (filterStatus === ENUM_FILTER_STATUS.SCORE_DESC) {
            setCandidateQueryMode("score_desc");
            setCandidatePageCursors({ 1: null });
            setCandidateHasMore(false);
            setCurrentPage(1);
            loadCandidatePage(1, "score_desc");
            return;
        }
        setCandidateQueryMode("default");
        const statusForApi = filterStatus;
        if (filterDateStatus == ENUM_FILTER_DATE.CUSTOM && startDate && endDate) {
            if (dayjs(startDate).isAfter(dayjs(endDate))) {
                alert("วันที่เริ่มต้นต้องน้อยกว่าวันที่สิ้นสุด");
                return;
            }
            getAllCandidateByFilter(interview_id, statusForApi,
                dayjs(startDate).toDate().toLocaleDateString(), dayjs(endDate).toDate().toLocaleDateString()).then((res) => {
                    if (res.data.is_success) {
                        if (res.data.data.length == 0) {
                            setCandidateList([]);
                            setCurrentPage(1);
                            setCandidateHasMore(false);
                            setCandidatePageCursors({ 1: null });
                            setCandidateProfile(undefined);
                            setLoadingReport(false);
                        } else {
                            const result = res.data.data as Candidate[];
                            setCandidateList(result);
                            setCurrentPage(1);
                            setCandidateHasMore(false);
                            setCandidatePageCursors({ 1: null });
                            console.log(result);
                            if (result && result.length > 0) {
                                setCandidateProfile(result[0]);
                                if (candidate_id) {
                                    getCandidateByCandidateID(interview_id, candidate_id);
                                    setLoadingReport(false);
                                } else {
                                    navigate("/" + tokenService.getHR9CompanyUUID() + "/job/" + interview_id + "/" + result[0].candidate_id)

                                }

                            }
                        }

                    }
                })
        } else {
            getAllCandidateByFilter(interview_id, statusForApi,
                "", "").then((res) => {
                    if (res.data.is_success) {
                        if (res.data.data.length == 0) {
                            setCandidateList([]);
                            setCurrentPage(1);
                            setCandidateHasMore(false);
                            setCandidatePageCursors({ 1: null });
                            setCandidateProfile(undefined);
                            setLoadingReport(false);
                        } else {
                            const result = res.data.data as Candidate[];
                            setCandidateList(result);
                            setCurrentPage(1);
                            setCandidateHasMore(false);
                            setCandidatePageCursors({ 1: null });
                            console.log(result);
                            if (result && result.length > 0) {
                                setCandidateProfile(result[0]);
                                if (candidate_id) {
                                    getCandidateByCandidateID(interview_id, candidate_id);
                                    setLoadingReport(false);
                                } else {
                                    navigate("/" + tokenService.getHR9CompanyUUID() + "/job/" + interview_id + "/" + result[0].candidate_id)

                                }

                            }
                        }

                    }
                })
        }

    }

    const clickShowFilter = () => {
        setIsFilter(!isFilter);
    }

    const clickCleanData = () => {
        cleanCandidate(interview_id).then((res) => {
            console.log(res);
        });
    }
    const toggleCandidateSort = (key: CandidateSortKey) => {
        setCandidateSort((prev) => {
            if (prev.key === key) {
                return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
            }
            return { key, direction: "asc" };
        });
    };
    const filteredCandidateList = candidateList.filter(
        (item) => item.status !== "DELETED"
    );
    const getCandidateRankingPercent = (item: Candidate) => {
        if (item.custom_measure_match_score == null || !Number.isFinite(item.custom_measure_match_score)) return null;
        return Math.max(0, Math.min(100, Math.round(Number(item.custom_measure_match_score) * 10)));
    };
    const getCandidateDisplayDateMs = (item: Candidate) => {
        const isComplete = item.interview_status === "COMPLETED";
        const dateText = isComplete ? item.created_at : item.interview_start_date;
        if (!dateText) return 0;
        const ms = new Date(dateText).getTime();
        return Number.isFinite(ms) ? ms : 0;
    };
    const sortedCandidates = [...filteredCandidateList].sort((a, b) => {
        let aValue: string | number = "";
        let bValue: string | number = "";
        switch (candidateSort.key) {
            case "name":
                aValue = `${a.firstname || ""} ${a.lastname || ""}`.trim().toLowerCase();
                bValue = `${b.firstname || ""} ${b.lastname || ""}`.trim().toLowerCase();
                break;
            case "ranking":
                aValue = getCandidateRankingPercent(a) ?? -1;
                bValue = getCandidateRankingPercent(b) ?? -1;
                break;
            case "email":
                aValue = String(a.email || "").toLowerCase();
                bValue = String(b.email || "").toLowerCase();
                break;
            case "job":
                aValue = `${a.jobTitle || ""} ${a.jobExp || ""}`.trim().toLowerCase();
                bValue = `${b.jobTitle || ""} ${b.jobExp || ""}`.trim().toLowerCase();
                break;
            case "status":
                aValue = String(a.interview_status || "").toLowerCase();
                bValue = String(b.interview_status || "").toLowerCase();
                break;
            case "date":
                aValue = getCandidateDisplayDateMs(a);
                bValue = getCandidateDisplayDateMs(b);
                break;
        }
        if (aValue < bValue) return candidateSort.direction === "asc" ? -1 : 1;
        if (aValue > bValue) return candidateSort.direction === "asc" ? 1 : -1;
        return 0;
    });
    const totalPages = candidateHasMore ? currentPage + 1 : currentPage;
    const paginatedCandidates = sortedCandidates;

    const isGeneralQuestionSet =
        String(interviewModel?.job_position?.question_type || "").toLowerCase() === "general";
    const generalObjectiveDisplay = isGeneralQuestionSet
        ? String(
              (interviewModel?.job_position?.job_advance as { job_description?: string } | undefined)
                  ?.job_description || "",
          ).trim()
        : "";

    const showCustomMeasureOnCandidateCards =
        !isGeneralQuestionSet && !!(interviewModel?.custom_measurement_criteria ?? "").trim();
    const getCustomMeasureScorePercent = (score?: number | null) => {
        if (score == null || !Number.isFinite(score)) return 0;
        return Math.max(0, Math.min(100, Math.round(score * 10)));
    };
    const getCustomMeasureScoreClassName = (percent: number) => {
        // Match tone with candidate report score colors.
        if (percent <= 20) return "candidate-custom-measure-pill--low";
        if (percent >= 80) return "candidate-custom-measure-pill--high";
        return "candidate-custom-measure-pill--mid";
    };
    const interviewAccessMode = String(
        interviewModel?.interview_access ||
            (interviewModel?.job_position as { interview_access?: string } | undefined)?.interview_access ||
            "private",
    ).toLowerCase();
    const isPublicInterviewSet = interviewAccessMode === "public";
    const canEditGeneralQuestionSet =
        isGeneralQuestionSet &&
        candidateList.length === 0 &&
        !isLoadingCandidateList &&
        profileModel?.roleName !== "ROLE_VIEWER";
    const renderSortIndicator = (key: CandidateSortKey) => {
        if (candidateSort.key !== key) return "↕";
        return candidateSort.direction === "asc" ? "↑" : "↓";
    };

    const handleClickAddUser = (listUser: any) => {

        addUsersToJob(company_id, interview_id, listUser).then((res) => {
            console.log(res);
            if (res.data) {
                if (profileModel.roleName === "ROLE_SUPER_ADMIN") {
                    getJobQuestionId();
                } else {
                    getJobQuestionIdByUserID(profileModel.uuid);
                }
            }

        });
    }

    const sharePublicLink = async () => {
        try {
            // Use URL params (authoritative) instead of interviewModel fields,
            // because some general question sets may be missing root-level company_id
            // and produce URLs like ".../undefined/job-public/...".
            const base = String(config.share.url || "").trim().replace(/\/+$/, "");
            const cid = interviewModel?.company_id || company_id;
            const jqid = interviewModel?.job_question_id || interview_id;
            if (!base || !cid || !jqid) {
                alert("ไม่สามารถสร้างลิงก์สำหรับแชร์ได้ (ข้อมูลไม่ครบ)");
                return;
            }
            const url = `${base}/${cid}/job-public/${jqid}`;
            await navigator.clipboard.writeText(url);
            alert('URL copied to clipboard!');
        } catch (err) {
            console.error('Failed to copy URL:', err);
        }
    }

    /** ใช้ POST /report/filter-resumes เดียว — ได้ total + grouped_by_utm_source (ไม่เรียก all-resumes ซ้ำ) */
    const getFilterResumesInsight = async () => {
        try {
            const res = await getAllInsightFilterResume(company_id, interview_id);
            if (res.data?.is_success) {
                setTotalResume(typeof res.data.total === "number" ? res.data.total : 0);
            } else {
                setTotalResume(0);
            }
        } catch {
            setTotalResume(0);
        }
    }

    const handleDownloadPDF = async () => {
        if (reportRef.current) {
            const canvas = await html2canvas(reportRef.current, { scale: 2 });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF({
                orientation: "portrait",
                unit: "pt",
                format: "a4"
            });
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
            pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
            pdf.save("candidate-report.pdf");
        }
    };

    return (
        <div className="jd-page">
            {/* ── Full-page loading ── */}
            {isLoading ? (
                <div className="jd-loading">
                    <CircularProgress size={28} sx={{ color: "#4A25E1" }} />
                    <span style={{ fontSize: 14, color: "#9ca3af" }}>กำลังโหลดข้อมูล</span>
                </div>
            ) : interviewModel && (
                <>
                    {/* ══ Header card ══════════════════════════════ */}
                    <div className="jd-header">
                        <div className="jd-header-top">
                            {/* Title + meta */}
                            <div style={{ display: "flex", flexDirection: "column", gap: 6, flex: 1, minWidth: 0 }}>
                                <span className="jd-job-title">{interviewModel.job_position.name}</span>
                                <div className="jd-meta-row">
                                    {interviewModel.job_position.job_title && (
                                        <span className="jd-meta-chip"><span className="jd-chip-label">ตำแหน่ง</span>{interviewModel.job_position.job_title}</span>
                                    )}
                                    {interviewModel.job_position.job_exp && (
                                        <span className="jd-meta-chip"><span className="jd-chip-label">ประสบการณ์</span>{interviewModel.job_position.job_exp}</span>
                                    )}
                                    {interviewModel.job_position.job_level && (
                                        <span className="jd-meta-chip"><span className="jd-chip-label">ระดับ</span>{interviewModel.job_position.job_level}</span>
                                    )}
                                    {interviewModel.job_position.job_industry && (
                                        <span className="jd-meta-chip"><span className="jd-chip-label">Industry</span>{interviewModel.job_position.job_industry}</span>
                                    )}
                                    {interviewModel.job_position.job_department && (
                                        <span className="jd-meta-chip"><span className="jd-chip-label">Dept</span>{interviewModel.job_position.job_department}</span>
                                    )}
                                    {interviewModel.job_position.job_salary && (
                                        <span className="jd-meta-chip"><span className="jd-chip-label">เงินเดือน</span>{interviewModel.job_position.job_salary}</span>
                                    )}
                                    <span className="jd-meta-chip">
                                        <span className="jd-chip-label">สร้าง</span>
                                        {interviewModel.created_at ? formatDateTime(new Date(interviewModel.created_at)) : "-"}
                                    </span>
                                    <span className="jd-meta-chip">
                                        <span className="jd-chip-label">โดย</span>{interviewModel.created_by || "-"}
                                    </span>
                                    <span className="jd-meta-chip">
                                        <span className="jd-chip-label">Resumes</span>{totalResume}
                                    </span>
                                    {!isGeneralQuestionSet && mappedJobIdShanti && (
                                        <span className="jd-tag jd-tag-blue">
                                            Shanti: {jobList.find(j => j.uuid === mappedJobIdShanti)?.name || mappedJobIdShanti}
                                        </span>
                                    )}
                                    {!isGeneralQuestionSet && (interviewModel.custom_measurement_criteria ?? "").trim() && (
                                        <span className="jd-tag jd-tag-purple">Custom Insight ✓</span>
                                    )}
                                    <span className={`jd-tag ${isPublicInterviewSet ? "jd-tag-green" : "jd-tag-slate"}`}>
                                        {isPublicInterviewSet ? "Public Set" : "Private Set"}
                                    </span>
                                </div>
                            </div>

                            {/* Action buttons */}
                            <div className="jd-header-actions">
                                {canEditGeneralQuestionSet && (
                                    <button
                                        type="button"
                                        className="jd-add-btn jd-edit-general-btn"
                                        onClick={() =>
                                            navigate(
                                                "/" + company_id + "/edit-general-questions/" + interview_id,
                                            )
                                        }
                                    >
                                        แก้ไขชุดคำถามทั่วไป
                                    </button>
                                )}
                                <button className="jd-add-btn" onClick={onClickAddCandidate}>
                                    <img src={PLUS_ICON} className="icon" />เพิ่มผู้สมัคร
                                </button>
                                <button className="jd-add-btn" onClick={onClickAddCandidatesBulk}>
                                    <img src={PLUS_ICON} className="icon" />เพิ่มหลายคน
                                </button>
                                {canShowForceRegenerateAllReports && (
                                    <MuiButton
                                        variant="outlined"
                                        size="small"
                                        disabled={forceRegenerateAllReportsRunning || getForceRegenerateReportTargets().length === 0}
                                        onClick={() => setConfirmForceRegenerateAllReports(true)}
                                        sx={{
                                            height: 36,
                                            px: 2,
                                            borderColor: "#7c3aed",
                                            color: "#7c3aed",
                                            whiteSpace: "nowrap",
                                            textTransform: "none",
                                            fontSize: 13,
                                        }}
                                    >
                                        {forceRegenerateAllReportsRunning
                                            ? <><CircularProgress size={13} color="inherit" sx={{ mr: 1 }} /> กำลังรัน…</>
                                            : "Force regenerate ทั้งชุด"}
                                    </MuiButton>
                                )}
                                {profileModel?.roleName === "ROLE_SUPER_ADMIN" && (
                                    <button className="jd-add-btn" onClick={handleAddUser}>
                                        <img src={PLUS_ICON} className="icon" />เพิ่มผู้ดูแล
                                    </button>
                                )}
                                <button
                                    className={`jd-icon-btn${isJobSettingsOpen ? " jd-settings-btn-active" : ""}`}
                                    onClick={() => setIsJobSettingsOpen(v => !v)}
                                    title="Settings"
                                >
                                    ⚙
                                </button>
                                <button className="jd-icon-btn" onClick={sharePublicLink} title="Share public link">
                                    <FontAwesomeIcon icon={faShare} style={{ fontSize: 13 }} />
                                </button>
                                {profileModel?.roleName === "ROLE_SUPER_ADMIN" && (
                                    <img
                                        src={TRASH_IMG}
                                        className="jd-icon-btn"
                                        onClick={deleteJob}
                                        title="Archive job"
                                        style={{ cursor: "pointer", opacity: 0.5 }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    {/* ══ Settings panel (collapsible) ═════════════ */}
                    <Collapse in={isJobSettingsOpen}>
                        <div className="jd-settings-panel">
                            {isGeneralQuestionSet ? (
                                <div className="jd-settings-section">
                                    <div className="jd-settings-section-title">
                                        <span>Objective ของชุดคำถาม</span>
                                    </div>
                                    <p style={{ fontSize: 12, color: "#64748b", margin: "0 0 8px" }}>
                                        เป้าหมายที่ตั้งตอนสร้างชุดคำถามทั่วไป — ใช้ประกอบการวิเคราะห์คำตอบผู้สมัคร (เช่น แท็บวิเคราะห์ Objective ในรายงานผู้สมัคร)
                                    </p>
                                    <div
                                        style={{
                                            whiteSpace: "pre-wrap",
                                            background: "#faf5ff",
                                            border: "1px solid #e9d5ff",
                                            borderRadius: 8,
                                            padding: "12px 14px",
                                            fontSize: "14px",
                                            lineHeight: 1.65,
                                            color: "#1e293b",
                                        }}
                                    >
                                        {generalObjectiveDisplay ||
                                            "— ยังไม่ได้กรอก Objective — ใช้ปุ่ม「แก้ไขชุดคำถามทั่วไป」เมื่อยังไม่มีผู้สมัครเพื่อเพิ่มหรือแก้ไข"}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {/* Job Mapping */}
                                    <div className="jd-settings-section">
                                        <div className="jd-settings-section-title">
                                            <span>Job Mapping (Shanti)</span>
                                            {isLoadingJobs && <CircularProgress size={14} />}
                                        </div>
                                        <div className="jd-settings-row">
                                            <FormControl fullWidth size="small">
                                                <InputLabel>เลือก Job จาก Shanti</InputLabel>
                                                <Select
                                                    value={selectedJobId}
                                                    onChange={(e) => setSelectedJobId(e.target.value as string)}
                                                    disabled={isLoadingJobs || !!mappedJobIdShanti}
                                                    label="เลือก Job จาก Shanti"
                                                >
                                                    {jobList
                                                        .filter(job => job.uuid !== mappedJobIdShanti)
                                                        .map(job => (
                                                            <MenuItem key={job.uuid} value={job.uuid}>
                                                                {job.name || job.title || job.uuid}
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                            </FormControl>
                                            {mappedJobIdShanti ? (
                                                <MuiButton variant="outlined" color="error" onClick={handleRemoveJobIdShanti} size="small">Remove</MuiButton>
                                            ) : (
                                                <MuiButton variant="contained" onClick={handleUpdateJobIdShanti} disabled={!selectedJobId || isLoadingJobs} size="small"
                                                    sx={{ backgroundColor: "#4A25E1", "&:hover": { backgroundColor: "#3b1db8" }, whiteSpace: "nowrap" }}>
                                                    Map Job
                                                </MuiButton>
                                            )}
                                        </div>
                                        {mappedJobIdShanti && (
                                            <Box sx={{ mt: 1 }}>
                                                <Chip
                                                    label={jobList.find(j => j.uuid === mappedJobIdShanti)?.name || jobList.find(j => j.uuid === mappedJobIdShanti)?.title || mappedJobIdShanti}
                                                    onDelete={handleRemoveJobIdShanti}
                                                    color="primary"
                                                    size="small"
                                                />
                                            </Box>
                                        )}
                                    </div>

                                    {/* Custom Insight */}
                                    <div className="jd-settings-section">
                                        <div className="jd-settings-section-title">
                                            <span>การวัดผลร่วม (Custom Insight)</span>
                                            <MuiButton variant="outlined" size="small"
                                                onClick={() => setIsCustomMeasureExpanded((v) => !v)}
                                                sx={{ borderColor: "#e2e8f0", color: "#334155", fontSize: 12, py: 0.3 }}>
                                                {isCustomMeasureExpanded ? "ซ่อน" : "ดูเนื้อหา"}
                                            </MuiButton>
                                        </div>
                                        {customMeasureFeedback && (
                                            <Alert severity={customMeasureFeedback.severity} sx={{ mb: 1, fontSize: 13 }} onClose={() => setCustomMeasureFeedback(null)}>
                                                {customMeasureFeedback.text}
                                            </Alert>
                                        )}
                                        {isCustomMeasureExpanded ? (
                                            isEditingCustomMeasure ? (
                                                <>
                                                    <TextField fullWidth multiline minRows={4} label="เกณฑ์การวัดผล"
                                                        placeholder="เช่น ความคุ้นเคยกับ Agile, ทักษะสื่อสารกับลูกค้า…"
                                                        value={customMeasureDraft} onChange={(e) => setCustomMeasureDraft(e.target.value)}
                                                        inputProps={{ maxLength: 4000 }} helperText={`${customMeasureDraft.length}/4000`} size="small"
                                                    />
                                                    <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-end", gap: 1 }}>
                                                        {interviewModel?.custom_measurement_criteria?.trim() && (
                                                            <MuiButton variant="outlined" size="small" disabled={savingCustomMeasure}
                                                                onClick={() => { setIsEditingCustomMeasure(false); setCustomMeasureDraft(interviewModel.custom_measurement_criteria ?? ""); }}>
                                                                ยกเลิก
                                                            </MuiButton>
                                                        )}
                                                        <MuiButton variant="contained" size="small" disabled={savingCustomMeasure}
                                                            onClick={handleSaveCustomMeasurementCriteria}
                                                            sx={{ backgroundColor: "#4A25E1", "&:hover": { backgroundColor: "#3b1db8" } }}>
                                                            {savingCustomMeasure ? <CircularProgress size={15} color="inherit" /> : "บันทึกเกณฑ์"}
                                                        </MuiButton>
                                                    </Box>
                                                </>
                                            ) : (
                                                <>
                                                    <div style={{ whiteSpace: "pre-wrap", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, padding: "10px 12px", fontSize: "13px", lineHeight: 1.6, color: "#1f2937" }}>
                                                        {interviewModel?.custom_measurement_criteria || "-"}
                                                    </div>
                                                    <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-end" }}>
                                                        <MuiButton variant="outlined" size="small"
                                                            onClick={() => { setIsCustomMeasureExpanded(true); setIsEditingCustomMeasure(true); }}
                                                            sx={{ borderColor: "#4A25E1", color: "#4A25E1", fontSize: 12 }}>
                                                            แก้ไข
                                                        </MuiButton>
                                                    </Box>
                                                </>
                                            )
                                        ) : (
                                            <p style={{ fontSize: 13, color: "#9ca3af", margin: 0 }}>
                                                {(interviewModel?.custom_measurement_criteria ?? "").trim()
                                                    ? 'เกณฑ์ถูกตั้งค่าแล้ว — กด "ดูเนื้อหา" เพื่อแก้ไข'
                                                    : 'ยังไม่มีเกณฑ์ — กด "ดูเนื้อหา" เพื่อตั้งค่า'}
                                            </p>
                                        )}
                                        {interviewModel?.custom_measurement_criteria?.trim() && (
                                            <Box sx={{ mt: 1, display: "flex", gap: 1, flexWrap: "wrap" }}>
                                                <MuiButton variant="outlined" size="small" onClick={() => setCustomMeasureDashboardOpen(true)}
                                                    sx={{ borderColor: "#0f766e", color: "#0f766e", fontSize: 12 }}>ดู Dashboard</MuiButton>
                                                <MuiButton variant="outlined" size="small"
                                                    disabled={reanalyzeAllCustomInsightRunning || savingCustomMeasure || getCustomInsightReanalyzeTargets().length === 0}
                                                    onClick={() => setConfirmReanalyzeAllCustomInsight(true)}
                                                    sx={{ borderColor: "#7c3aed", color: "#7c3aed", fontSize: 12, display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                                                    {reanalyzeAllCustomInsightRunning
                                                        ? <><CircularProgress size={13} color="inherit" /> กำลังวิเคราะห์…</>
                                                        : "Re Analyze All"}
                                                </MuiButton>
                                            </Box>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </Collapse>

                    {/* ══ Tabs card ═════════════════════════════════ */}
                    <div className="jd-tabs-card">
                        <Box sx={{ borderBottom: 1, borderColor: "divider", px: 1 }}>
                            <Tabs value={tabActive} onChange={(_, v) => handleChangeTab(v)}>
                                <Tab value={0} label={`ผู้สมัคร (${candidateList.length})`} />
                                <Tab value={1} label={`คำถาม (${interviewModel.questions.length})`} />
                                <Tab value={2} label={isGeneralQuestionSet ? "Dashboard" : "Insight"} />
                            </Tabs>
                        </Box>

                        <div className="jd-tab-body">
                            {/* ── Tab 0: Candidates ── */}
                            {tabActive === 0 && (
                                <div className="ct-tab-panel">
                                    {/* Toolbar */}
                                    <div className="ct-toolbar">
                                        <div className="ct-toolbar-left">
                                            <FormControl size="small" sx={{ minWidth: 150 }}>
                                                <InputLabel>สถานะ</InputLabel>
                                                <Select value={filterStatus} onChange={handleChangeFilter} label="สถานะ">
                                                    <MenuItem value={ENUM_FILTER_STATUS.ALL}>ทั้งหมด</MenuItem>
                                                    <MenuItem value={ENUM_FILTER_STATUS.INTERVIEW}>รอสัมภาษณ์</MenuItem>
                                                    <MenuItem value={ENUM_FILTER_STATUS.COMPLETED}>สัมภาษณ์แล้ว</MenuItem>
                                                    <MenuItem value={ENUM_FILTER_STATUS.SCORE_DESC}>คะแนนมากไปน้อย</MenuItem>
                                                </Select>
                                            </FormControl>
                                            <FormControl size="small" sx={{ minWidth: 120 }}>
                                                <InputLabel>วันที่</InputLabel>
                                                <Select value={filterDateStatus} onChange={handleChangeDateFilter} label="วันที่">
                                                    <MenuItem value={ENUM_FILTER_DATE.ALL}>ทั้งหมด</MenuItem>
                                                    <MenuItem value={ENUM_FILTER_DATE.CUSTOM}>เลือกวันที่</MenuItem>
                                                </Select>
                                            </FormControl>
                                            {filterDateStatus === ENUM_FILTER_DATE.CUSTOM && (
                                                <>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker label="Start date" value={dayjs(startDate)} onChange={(v) => handleDateChange(v, "Start Date")}
                                                            slotProps={{ textField: { size: "small", sx: { width: 150 } } }} />
                                                    </LocalizationProvider>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker label="End date" value={dayjs(endDate)} onChange={(v) => handleDateChange(v, "End Date")}
                                                            slotProps={{ textField: { size: "small", sx: { width: 150 } } }} />
                                                    </LocalizationProvider>
                                                </>
                                            )}
                                            <MuiButton variant="contained" size="small" onClick={clickFilter}
                                                sx={{ height: 38, px: 2.5, backgroundColor: "#4A25E1", "&:hover": { backgroundColor: "#3b1db8" }, whiteSpace: "nowrap" }}>
                                                กรอง
                                            </MuiButton>
                                            {canShowForceRegenerateAllReports && (
                                                <MuiButton
                                                    variant="outlined"
                                                    size="small"
                                                    disabled={forceRegenerateAllReportsRunning || getForceRegenerateReportTargets().length === 0}
                                                    onClick={() => setConfirmForceRegenerateAllReports(true)}
                                                    sx={{ height: 38, px: 2.5, borderColor: "#7c3aed", color: "#7c3aed", whiteSpace: "nowrap" }}
                                                >
                                                    {forceRegenerateAllReportsRunning
                                                        ? <><CircularProgress size={13} color="inherit" sx={{ mr: 1 }} /> กำลังรัน…</>
                                                        : "Force regenerate report ทั้งชุด"}
                                                </MuiButton>
                                            )}
                                        </div>
                                    </div>

                                    {/* Non-active summary */}
                                    {nonActiveSummary != null && (
                                        <div className="ct-nonactive-row">
                                            <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }}>
                                                <span style={{ fontSize: 13, color: "#6b7280" }}>ไม่แสดงในรายการ:</span>
                                                <Chip size="small" label={`ลบแล้ว ${nonActiveSummary.deleted_count}`} variant="outlined" sx={{ fontSize: 12, height: 22 }} />
                                                <Chip size="small" label={`ปฏิเสธ ${nonActiveSummary.rejected_count}`} color="warning" variant="outlined" sx={{ fontSize: 12, height: 22 }} />
                                                <MuiButton size="small" variant="text" sx={{ textTransform: "none", fontSize: 12, py: 0, minHeight: 0 }}
                                                    onClick={() => { const next = !nonActivePanelOpen; setNonActivePanelOpen(next); if (next) loadNonActiveList(nonActiveStatusTab); }}>
                                                    {nonActivePanelOpen ? "ซ่อน" : "ดูรายชื่อ"}
                                                </MuiButton>
                                                <Collapse in={nonActivePanelOpen} sx={{ width: "100%" }}>
                                                    <Box sx={{ pt: 1 }}>
                                                        <ToggleButtonGroup size="small" value={nonActiveStatusTab} exclusive
                                                            onChange={(_, v) => { if (v != null) { setNonActiveStatusTab(v); loadNonActiveList(v); } }}>
                                                            <ToggleButton value="DELETED" sx={{ fontSize: 12 }}>ลบแล้ว ({nonActiveSummary.deleted_count})</ToggleButton>
                                                            <ToggleButton value="REJECTED" sx={{ fontSize: 12 }}>ปฏิเสธ ({nonActiveSummary.rejected_count})</ToggleButton>
                                                        </ToggleButtonGroup>
                                                        {nonActiveListLoading ? (
                                                            <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}><CircularProgress size={22} /></Box>
                                                        ) : nonActiveList.length === 0 ? (
                                                            <Alert severity="info" sx={{ mt: 1, py: 0.5, fontSize: 13 }}>ไม่มีรายชื่อในหมวดนี้</Alert>
                                                        ) : (
                                                            <Box component="ul" sx={{ m: 0, mt: 1, pl: 2, maxHeight: 200, overflow: "auto" }}>
                                                                {nonActiveList.map((row) => (
                                                                    <Box component="li" key={row.candidate_id || row.email} sx={{ fontSize: 13, mb: 1, color: "#374151", listStyle: "disc" }}>
                                                                        <strong>{row.firstname} {row.lastname}</strong>
                                                                        <span style={{ color: "#6b7280" }}> · {row.email}</span>
                                                                        <span style={{ display: "block", color: "#9ca3af", fontSize: 12, marginTop: 2 }}>
                                                                            {row.status === "DELETED" ? "ลบเมื่อ" : "ปฏิเสธเมื่อ"}:{" "}
                                                                            {formatNonActiveAuditWhen(row.deleted_at || row.rejected_at || row.updated_at)}{" "}
                                                                            · {formatActorLabel(row.deleted_by_email || row.rejected_by_email, row.deleted_by_uid || row.rejected_by_uid)}
                                                                        </span>
                                                                    </Box>
                                                                ))}
                                                            </Box>
                                                        )}
                                                    </Box>
                                                </Collapse>
                                            </Box>
                                        </div>
                                    )}

                                    {/* Empty state */}
                                    {candidateList.length === 0 && (
                                        <div className="job-detail-no-candidate-control">
                                            <img src={ADD_CANDIDATE_IMG} className="icon" alt="" />
                                            <span className="no-candidate-text">ยังไม่มีผู้สมัคร</span>
                                            <button className="button-add-candidate" onClick={onClickAddCandidate}>
                                                <img src={PLUS_ICON} className="icon" alt="" /> เพิ่มผู้สมัคร
                                            </button>
                                            <button className="button-add-candidate" onClick={onClickAddCandidatesBulk}>
                                                <img src={PLUS_ICON} className="icon" alt="" /> เพิ่มผู้สมัครหลายคน
                                            </button>
                                        </div>
                                    )}

                                    {/* Table */}
                                    {paginatedCandidates.length > 0 && (
                                        <table className="ct-table">
                                            <thead>
                                                <tr>
                                                    <th className="ct-th ct-col-name ct-th-sortable" onClick={() => toggleCandidateSort("name")}>
                                                        ชื่อ-นามสกุล <span className="ct-sort-indicator">{renderSortIndicator("name")}</span>
                                                    </th>
                                                    <th className="ct-th ct-col-ranking ct-th-sortable" onClick={() => toggleCandidateSort("ranking")}>
                                                        Ranking % <span className="ct-sort-indicator">{renderSortIndicator("ranking")}</span>
                                                    </th>
                                                    <th className="ct-th ct-col-email ct-th-sortable" onClick={() => toggleCandidateSort("email")}>
                                                        อีเมล <span className="ct-sort-indicator">{renderSortIndicator("email")}</span>
                                                    </th>
                                                    <th className="ct-th ct-col-job ct-hide-sm ct-th-sortable" onClick={() => toggleCandidateSort("job")}>
                                                        ตำแหน่ง / ประสบการณ์ <span className="ct-sort-indicator">{renderSortIndicator("job")}</span>
                                                    </th>
                                                    <th className="ct-th ct-col-status ct-th-sortable" onClick={() => toggleCandidateSort("status")}>
                                                        สถานะ <span className="ct-sort-indicator">{renderSortIndicator("status")}</span>
                                                    </th>
                                                    <th className="ct-th ct-col-date ct-hide-sm ct-th-sortable" onClick={() => toggleCandidateSort("date")}>
                                                        วันที่ <span className="ct-sort-indicator">{renderSortIndicator("date")}</span>
                                                    </th>
                                                    <th className="ct-th ct-col-actions"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paginatedCandidates.map((item) => {
                                                    if (item.status === "DELETED") return null;
                                                    const isActive = item.candidate_id === candidate_id;
                                                    const isComplete = item.interview_status === "COMPLETED";
                                                    return (
                                                        <tr key={item.candidate_id} className={`ct-row${isActive ? " ct-row-active" : ""}`} onClick={() => onclickCandidate(item)}>
                                                            <td className="ct-td ct-col-name">
                                                                <span className="ct-name-link">{item.firstname} {item.lastname}</span>
                                                            </td>
                                                            <td className="ct-td ct-col-ranking">
                                                                {isComplete && showCustomMeasureOnCandidateCards && item.custom_measure_match_score != null ? (
                                                                    <span className={`ct-score-pill ${getCustomMeasureScoreClassName(getCustomMeasureScorePercent(item.custom_measure_match_score))}`}>
                                                                        {getCustomMeasureScorePercent(item.custom_measure_match_score)}%
                                                                    </span>
                                                                ) : (
                                                                    <span className="ct-text-gray">-</span>
                                                                )}
                                                            </td>
                                                            <td className="ct-td ct-text-gray">{item.email}</td>
                                                            <td className="ct-td ct-hide-sm">{item.jobTitle || "-"}{item.jobExp ? ` · ${item.jobExp}` : ""}</td>
                                                            <td className="ct-td">
                                                                <span className={isComplete ? "ct-badge ct-badge-complete" : "ct-badge ct-badge-pending"}>
                                                                    {isComplete ? "Complete" : "Pending"}
                                                                </span>
                                                            </td>
                                                            <td className="ct-td ct-text-gray ct-hide-sm">
                                                                {isComplete
                                                                    ? (item.created_at ? formatDateThaiShort(item.created_at) : "-")
                                                                    : (item.interview_start_date ? formatDateThaiShort(item.interview_start_date) : "-")}
                                                            </td>
                                                            <td className="ct-td ct-col-actions" onClick={(e) => e.stopPropagation()}>
                                                                {!isComplete && (
                                                                    <FontAwesomeIcon
                                                                        icon={faPenToSquare}
                                                                        className="ct-action-icon"
                                                                        title="Edit candidate"
                                                                        onClick={() => onclickCandidate(item)}
                                                                    />
                                                                )}
                                                                <img src={SHARE_IMG} className="ct-action-icon" alt="" onClick={() => handleShareCandidate(item)} />
                                                                {canDeleteCandidate(profileModel?.roleName) && (
                                                                    <img src={TRASH_IMG} className="ct-action-icon" alt="" onClick={() => openDeleteCandidateModal(item.candidate_id)} />
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    )}

                                    {/* Pagination */}
                                    {filteredCandidateList.length > 0 && (
                                        <div className="ct-pagination-bar">
                                            <span className="ct-pagination-info">
                                                {filteredCandidateList.length} คน · หน้า {currentPage} of {totalPages}
                                            </span>
                                            <div className="ct-pagination-controls">
                                                <button type="button" className="ct-page-btn" disabled={currentPage === 1}
                                                    onClick={() => loadCandidatePage(Math.max(currentPage - 1, 1))}>
                                                    <FontAwesomeIcon icon={faChevronLeft} />
                                                </button>
                                                <span className="ct-page-num">{currentPage}</span>
                                                <button type="button" className="ct-page-btn" disabled={!candidateHasMore}
                                                    onClick={() => loadCandidatePage(currentPage + 1)}>
                                                    <FontAwesomeIcon icon={faChevronRight} />
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* ── Tab 1: Questions ── */}
                            {tabActive === 1 && (
                                <div className="jd-questions-panel">
                                    {interviewModel.questions.map((item, index) => (
                                        <div className="jd-question-item" key={index}>
                                            <span className="jd-question-number">{index + 1}</span>
                                            <div className="jd-question-body">
                                                <span className="jd-question-th">{item.question.th}</span>
                                                {item.question.en && (
                                                    <span className="jd-question-en">{item.question.en}</span>
                                                )}
                                                <div className="jd-question-tags">
                                                    <span className="jd-question-tag">
                                                        {item.topic === "general" ? "คำถามทั่วไป"
                                                            : item.topic === "standard_assessment" ? "คำถามจากบริษัท"
                                                            : item.topic === "additional_question" ? "คำถามเพิ่มเติม"
                                                            : item.topic}
                                                    </span>
                                                    {item.need_skills?.filter(Boolean).map((skill, si) => (
                                                        <span className="jd-question-tag jd-question-tag-skill" key={si}>#{skill}</span>
                                                    ))}
                                                </div>
                                                {isMultipleChoiceLike(item.question_type) && item.choices && item.choices.length > 0 && (
                                                    <div className="jd-choice-box">
                                                        <span className="jd-choice-label">
                                                            {item.question_type === MULTIPLE_CHOICE_NO_ANSWER ? "ตัวเลือก (ไม่กำหนดข้อถูก)" : "ตัวเลือก (4 ข้อ)"}
                                                        </span>
                                                        {item.choices.map((choice, ci) => (
                                                            <div className="jd-choice-item" key={ci}>
                                                                <span className="jd-choice-num">{ci + 1}.</span>
                                                                <div>
                                                                    <div>{choice.th}</div>
                                                                    {choice.en && <div style={{ color: "#9ca3af", fontSize: 12 }}>{choice.en}</div>}
                                                                </div>
                                                            </div>
                                                        ))}
                                                        {item.question_type === MULTIPLE_CHOICE && (
                                                            <span className="jd-choice-answer">
                                                                ✓ เฉลย: ข้อที่ {Number(item.answer_choice?.answer_index) + 1}
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* ── Tab 2: Insight (default) / Dashboard (general) ── */}
                            {tabActive === 2 && (
                                <div className="jd-insight-panel">
                                    {isGeneralQuestionSet ? (
                                        <GeneralQuestionnaireDashboard
                                            jobQuestionId={interview_id}
                                            questions={interviewModel.questions}
                                            jobTitle={interviewModel.job_position?.name || interviewModel.job_position?.job_title}
                                            companyName={interviewModel.job_position?.company_name}
                                        />
                                    ) : (
                                        <InsightDashboardComponent
                                            companyId={company_id}
                                            jobQuestionId={interview_id}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}

            {/* ══ Modals ════════════════════════════════════ */}
            {isAddCandidate && (
                <AddCandidateModal isSubmittingStatus={isSubmittingCandidate}
                    isOpen={isAddCandidate} onClose={() => setIsAddCandidate(false)} onSubmit={submitCandidate} />
            )}
            {isAddCandidatesBulk && (
                <AddCandidatesBulkModal isOpen={isAddCandidatesBulk}
                    onClose={() => setIsAddCandidatesBulk(false)}
                    existingEmails={candidateList.map((c) => c.email)}
                    onConfirmInvite={submitCandidatesBulk} />
            )}
            {isDelete && (
                <ConfirmDeleteModal buttonCancel="ยกเลิก" buttonConfirm="เก็บเข้าคลัง"
                    message="ต้องการเก็บชุดคำถามนี้เข้าคลังหรือไม่?"
                    message2="ระบบจะตั้งสถานะเป็น ARCHIVED — ไม่แสดงใน hr-landing / บล็อกลิงก์ผู้สมัคร — คืน Template credit 1 ชุด (หากยัง ACTIVE) — และ void รายงานที่สัมภาษณ์จบแล้วของงานนี้ทั้งหมดเพื่อคืน Report credit"
                    isOpen={isDelete} onClose={() => setIsDelete(false)} onDelete={onConfirmDelete} />
            )}
            {isClickDeleteCandidate && (
                <ConfirmDeleteModal buttonCancel="ยกเลิก" buttonConfirm="ลบผู้สมัคร"
                    message="ยืนยันที่จะลบผู้สมัคร?"
                    message2="สถานะผู้สมัครจะถูกตั้งเป็นลบแล้ว หากสัมภาษณ์จบแล้ว ระบบจะยกเลิกการนับรายงานใน report credit (คืนเครดิตให้องค์กร)"
                    isOpen={isClickDeleteCandidate} onClose={closeDeleteCandidateModal} onDelete={onConfirmDeleteCandidate} />
            )}
            {isConfirmUnlock && (
                <ConfirmGeneralModal buttonCancel="ยกเลิก" buttonConfirm="ยืนยัน" icon={COIN_IMG}
                    message="ยืนยันที่จะเปิดดูผู้สมัคร?" message2="" isOpen={isConfirmUnlock}
                    onClose={() => setIsConfirmUnlock(false)} onConfrim={unlockCandidate} />
            )}
            <JobKpiDashboardModal open={customMeasureDashboardOpen} onClose={() => setCustomMeasureDashboardOpen(false)}
                companyId={company_id} jobQuestionId={interview_id} />
            {confirmReanalyzeAllCustomInsight && (
                <ConfirmGeneralModal buttonCancel="ยกเลิก" buttonConfirm="ยืนยัน" icon={AI_PURPLE}
                    message="Re Analyze All — Custom Insight"
                    message2={`จะวิเคราะห์ใหม่ตามเกณฑ์ปัจจุบันให้ผู้สมัครที่สัมภาษณ์แล้วและมีรายงาน ${getCustomInsightReanalyzeTargets().length} รายการ (เฉพาะ Custom Insight) แต่ละรายการอาจใช้เครดิต`}
                    isOpen={confirmReanalyzeAllCustomInsight}
                    onClose={() => setConfirmReanalyzeAllCustomInsight(false)}
                    onConfrim={handleConfirmReanalyzeAllCustomInsight} />
            )}
            {confirmForceRegenerateAllReports && (
                <ConfirmGeneralModal
                    buttonCancel="ยกเลิก"
                    buttonConfirm="ยืนยัน"
                    icon={AI_PURPLE}
                    message="Force regenerate report ทั้งชุด"
                    message2={`จะรันวิเคราะห์รายงานใหม่สำหรับผู้สมัครที่สัมภาษณ์เสร็จ ${getForceRegenerateReportTargets().length} รายการ (ระบบเลือก flow ตาม app_id / ประเภทชุดงานอัตโนมัติ)`}
                    isOpen={confirmForceRegenerateAllReports}
                    onClose={() => setConfirmForceRegenerateAllReports(false)}
                    onConfrim={handleConfirmForceRegenerateAllReports}
                />
            )}
            {isLoadingCandidateList && (
                <LoadingGeneralModal isOpen preventDismiss onClose={() => {}}
                    message="กำลังโหลดรายชื่อผู้สมัคร"
                    message2={`โหลดแล้ว ${candidateListLoadCount} คน`} />
            )}
            {bulkInviteProgress && (
                <LoadingGeneralModal isOpen preventDismiss onClose={() => {}}
                    message="กำลังส่งคำเชิญผู้สมัคร"
                    message2={`ส่งแล้ว ${bulkInviteProgress.done}/${bulkInviteProgress.total}${bulkInviteProgress.skipped ? ` (ข้าม ${bulkInviteProgress.skipped})` : ""}`} />
            )}
            {isSendingEmail && (
                <LoadingGeneralModal message="กำลังส่งอีเมล" message2="กรุณารอสักครู่"
                    isOpen={isSendingEmail} onClose={() => setIsSendingEmail(false)} />
            )}
            {isCandidateShare && shareID && interviewModel && (
                <ShareCandidateModal interview={interviewModel}
                    period={shareID.interview_end_date && shareID.interview_start_date ? formatInterviewDate(shareID.interview_start_date, shareID.interview_end_date) : "-"}
                    job_position={interviewModel.job_position}
                    isOpen={isCandidateShare} onClose={handleShareCandidate} candidate={shareID} />
            )}
            {isPremium && <PremiumModal isOpen={isPremium} onClose={handleClosePremium} onSubmit={submitPremium} />}
            {isAddUser && (
                <UserAccessModal onSubmit={handleClickAddUser} show={isAddUser}
                    initialUsers={interviewModel?.user_access} onHide={handleAddUser} />
            )}
        </div>
    )
}

export default JobQuestionDetail;